/**
 * Enum for router name
 * @readonly
 * @enum {String}
 */
export const ROUTER_NAME = Object.freeze({
	LOGIN: 'Login',
	USER_LIST: 'UserList',
	USER_CREATE: 'UserCreate',
	USER_EDIT: 'UserEdit',
	NOT_FOUND: 'PageNotFound',
	PERMISSION_DENIED: 'PagePermissionDenied',
	PROFILE_EDIT: 'ProfileEdit',
	DASHBOARD: 'Dashboard',
	ORDER_LIST: 'OrderList',
	ORDER_SINGLE: 'OrderSingle',
	STOCK_BROWSER: 'StockBrowserSkuList',
	STOCK_BROWSER_BRANCH_SINGLE: 'StockBrowserBranchSingle',
	STOCK_BROWSER_SKU_SINGLE: 'StockBrowserSkuSingle',
	CHANNEL_LIST: 'ChannelList',
	CHANNEL_CREATE: 'ChannelCreate',
	CHANNEL_SINGLE: 'ChannelSingle',
	ALOCATION_ONLINE_STOCK_LIST: 'AlocationOnlineStockList',
	ALOCATION_ONLINE_STOCK_CREATE: 'AlocationOnlineStockCreate',
	ALOCATION_ONLINE_STOCK_SINGLE: 'AlocationOnlineStockSingle',
	ALOCATION_CHANNEL_LIST: 'AlocationChannelList',
	ALOCATION_CHANNEL_CREATE: 'AlocationChannelCreate',
	ALOCATION_CHANNEL_SINGLE: 'AlocationChannelSingle',
	ALOCATION_ONLINE_GROUP: 'AlocationOnlineGroup',
	REPORTS: 'Reports',
	ERRORS: 'Errors',
	AUDIT_LOGS_LIST: 'AuditLogsList',
	AUDIT_LOG_DETAIL: 'AuditLogDetail',
});

/**
 * Enum for router page title
 * @readonly
 * @enum {String}
 */
export const ROUTER_PAGE_TITLE = Object.freeze({
	DEFAULT: 'Com7 - BNN-IM',
	USER_LIST: 'User management',
	USER_CREATE: 'Create new user',
	USER_EDIT: 'User management',
	EDIT_PROFILE: 'Edit profile',
	DASHBOARD: 'Dashboard',
	ORDER_LIST: 'Order lists',
	STOCK_BROWSER: 'Stock browser',
	CHANNEL_LIST: 'Channel management',
	CHANNEL_CREATE: 'Create a channel',
	CHANNEL_SINGLE: 'Channel management',
	ALOCATION_ONLINE_STOCK_LIST: 'Allocation to online stock',
	ALOCATION_ONLINE_STOCK_CREATE: 'Create rule for online stock',
	ALOCATION_ONLINE_STOCK_SINGLE: 'Allocation to online stock',
	ALOCATION_CHANNEL_LIST: 'Allocation to channels',
	ALOCATION_CHANNEL_CREATE: 'Create rule for channels',
	ALOCATION_CHANNEL_SINGLE: 'Allocation to channels',
	ALOCATION_ONLINE_GROUP: 'Online group management',
	REPORTS: 'Reports',
	ERRORS: 'Errors',
	AUDIT_LOG_LIST: 'Audit log list',
	AUDIT_LOG_DETAIL: 'Audit log detail',
});
